import type { Message } from '@interfaces/message';
import type { InputMessageReplyInfo } from '@store/types/input-message-reply-info';

import { getStore } from '@/store';

export function setInputMessageReplyInfo(message: Message) {
  const store = getStore<InputMessageReplyInfo>('inputMessageReplyInfo');
  store.setState(() => ({
    message,
  }));
}

export function removeInputMessageReplyInfo() {
  const store = getStore<InputMessageReplyInfo>('inputMessageReplyInfo');
  store.setState(() => ({
    message: undefined,
  }));
}
